import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

const ConfirmDialog = ( {open, onClose, title, text, okText, onOK} ) => {
  return <Dialog
open={open}
onClose={onClose}
aria-labelledby="confirm-dialog-title"
aria-describedby="confirm-dialog-description"
>
  <DialogTitle id="confirm-dialog-title">
    {open && title}
  </DialogTitle>
  <DialogContent>
    <DialogContentText id="confirm-dialog-description">
    {open && text}
    </DialogContentText>
  </DialogContent>
  <DialogActions>
    <Button onClick={onClose} autoFocus>Cancel</Button>
    <Button onClick={onOK}>{okText || "OK"}</Button>
  </DialogActions>
</Dialog>
}

export default ConfirmDialog;
